module.exports = __webpack_public_path__ + "static/media/supermarket.907b3556.svg";